export default __webpack_public_path__ + "static/media/play_arrow.7ca5f20c.svg";